/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TicketAttachment.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Grid, Typography } from "@mui/material";
import React from "react";
import CustomTabsV3 from "../../../components/customComponentsV2/common/tabs/CustomTabsV3";
import TicketTestCaseArtifact from "./TicketTestCaseArtifact";
import DynamicFormOld from "../dynamicFormFiles/dynamicFormOld";
import UpdateFormRenderer from "../../admin-settings/DynamicFormV2/updateForm";
import { useLocation } from "react-router-dom";
import ViewDynammicFormDetailsTemplate from "../../admin-settings/DynamicForms/viewDynamicFormTemplate";
import PreviewModalTemplate from "../../admin-settings/DynamicFormV2/previewModelTemplate";
import AttachmentList from "./ViewTicketAttachment";

function TicketAttachment({
  selectedTableRowData,
  setSelectedTableRowData,
  setDynamicFormData,
  dynamicFormData,
  onClose,
  fetchTickets,
  displayAddArtifact,
  formType,
  selectedComponent,
  componentType,
}) {
  console.log(dynamicFormData, "dynamicFormData");
  const location = useLocation();

  const isStimulationRoute =
    location.pathname === "/dashboard/doc_library/stimulation";

  // OR (recommended if query params / subroutes exist)
  const isStimulationRouteIncludes = location.pathname.includes(
    "/dashboard/doc_library/stimulation",
  );

  const hasAttachmentData = Array.isArray(dynamicFormData)
    ? dynamicFormData.length > 0
    : Boolean(dynamicFormData && Object.keys(dynamicFormData).length > 0);

  console.log(dynamicFormData, "dynamicFormData");
  return (
    <Grid container>
      <Grid item sm={12}>
        <CustomTabsV3
          tabs={[
            {
              name: "Form",
              count: "",
              content: (
                <div>
                  {dynamicFormData?.template_tag === "OLD" &&
                    !isStimulationRouteIncludes && (
                      <>
                        <DynamicFormOld
                          setDynamicFormData={setDynamicFormData}
                          dynamicFormData={dynamicFormData}
                          Title="Form Template"
                          ticketId={selectedTableRowData?.ticket_id}
                          selectedComponent={selectedComponent}
                          componentType={componentType}
                          formType={formType}
                        />
                      </>
                    )}

                  {dynamicFormData?.template_tag === "OLD" &&
                    isStimulationRouteIncludes && (
                      <ViewDynammicFormDetailsTemplate data={dynamicFormData} />
                    )}
                  {dynamicFormData?.template_tag === "NEW" &&
                    !isStimulationRouteIncludes && (
                      <UpdateFormRenderer
                        data={dynamicFormData}
                        selectedComponent={selectedComponent}
                        componentType={componentType}
                      />
                    )}

                  {dynamicFormData?.template_tag === "NEW" &&
                    isStimulationRouteIncludes && (
                      <PreviewModalTemplate pages={dynamicFormData?.fields} />
                    )}
                  {!hasAttachmentData && (
                    <Typography sx={{ textAlign: "center", p: 2 }}>
                      No attachment found
                    </Typography>
                  )}
                </div>
              ),
            },
            {
              name: "Test Attachment",
              count: "",
              content: (
                <TicketTestCaseArtifact
                  selectedTicketsTableRowData={selectedTableRowData}
                  setSelectedTicketsTableRowData={setSelectedTableRowData}
                  onClose={onClose}
                  fetchTickets={fetchTickets}
                  displayAddArtifact={displayAddArtifact}
                />
              ),
            },
            {
              name: "Ticket Attachment",
              count: "",
              content: (
                <AttachmentList
                  artefactDetails={
                    selectedTableRowData?.attachment_details || []
                  }
                  setSelectedTicketsTableRowData={setSelectedTableRowData}
                  onClose={onClose}
                  fetchTickets={fetchTickets}
                  displayAddArtifact={displayAddArtifact}
                />
              ),
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default TicketAttachment;
